var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import Typography from "@mui/material/Typography";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
var AdditionalProperties = function (props) {
    var isOutlined = props.variant === 'outlined';
    return (_jsxs(Accordion, __assign({ variant: isOutlined ? 'outlined' : 'elevation', disableGutters: true, sx: __assign({ boxShadow: isOutlined ? undefined : 'none', '&.MuiAccordion-root': {
                '&:before': {
                    display: 'none',
                },
                border: isOutlined ? undefined : 'none',
                borderRadius: isOutlined ? 1 : undefined,
                margin: isOutlined ? 0 : undefined,
                marginTop: isOutlined ? undefined : 4,
                overflow: isOutlined ? 'hidden' : undefined,
                '&.Mui-expanded': {
                    minHeight: 'unset',
                    margin: isOutlined ? 0 : undefined,
                    marginTop: isOutlined ? undefined : 4,
                }
            }, '& .MuiAccordionSummary-root': {
                px: isOutlined ? 2 : 0,
                py: isOutlined ? 1.5 : 0,
                minHeight: 'unset',
                '&.Mui-expanded': {
                    minHeight: 'unset',
                },
                '& .MuiAccordionSummary-content': {
                    margin: 0,
                    '&.Mui-expanded': {
                        margin: 0,
                    },
                }
            }, '& .MuiAccordionDetails-root': {
                padding: isOutlined ? undefined : 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 1
            } }, props.sx), expanded: props.expanded, defaultExpanded: props.defaultExpanded }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ArrowDownwardIcon, {}), "aria-controls": "panel1-content", id: "panel1-header" }, { children: _jsx(Typography, __assign({ variant: 'h6' }, { children: props.title })) })), _jsxs(AccordionDetails, { children: [!!props.subtitle && (_jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary' }, { children: props.subtitle }))), props.children] })] })));
};
export default AdditionalProperties;
